if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener(
              'click',
              this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false)
            );
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) =>
          el.classList.remove('is-active')
        );

        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            if (activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail?.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((el) => el.removeAttribute('aria-current'));

        thumbnail.querySelector('button').setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('img');
        if (!image || !this.elements.liveRegion) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation')
        );
      }

      /* 🔥 ALT-TAG-BASED FILTER */
      filterByGripType(gripType) {
        if (!gripType) return;

        const viewerItems = this.elements.viewer.querySelectorAll('[data-media-id]');
        const thumbItems = this.elements.thumbnails?.querySelectorAll('[data-target]') || [];
        let firstValid = null;

        viewerItems.forEach((item) => {
          const img = item.querySelector('img');
          const alt = img?.getAttribute('alt')?.toLowerCase() || '';
          const show = alt.includes(`griptype:${gripType}`);
          item.style.display = show ? '' : 'none';
          if (show && !firstValid) firstValid = item.dataset.mediaId;
        });

        thumbItems.forEach((thumb) => {
          const target = thumb.dataset.target;
          const linked = this.elements.viewer.querySelector(
            `[data-media-id="${target}"]`
          );
          thumb.style.display =
            linked && linked.style.display !== 'none' ? '' : 'none';
        });

        if (firstValid) this.setActiveMedia(firstValid, true);
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }
    }
  );
}

/* =========================================================
   ✅ CORRECT VARIANT CHANGE HOOK (DAWN)
   ========================================================= */
document.addEventListener('change', (event) => {
  const picker = event.target.closest('variant-selects');
  if (!picker) return;

  const values = Array.from(
    picker.querySelectorAll('input:checked, select')
  )
    .map((el) => el.value)
    .join(' ')
    .toLowerCase();

  let gripType = null;
  if (values.includes('without')) gripType = 'without';
  if (values.includes('integrated')) gripType = 'integrated';

  if (!gripType) return;

  document.querySelectorAll('media-gallery').forEach((gallery) => {
    gallery.filterByGripType?.(gripType);
  });
});

/* =========================================================
   ✅ INITIAL LOAD
   ========================================================= */
document.addEventListener('DOMContentLoaded', () => {
  const picker = document.querySelector('variant-selects');
  if (!picker) return;

  const values = Array.from(
    picker.querySelectorAll('input:checked, select')
  )
    .map((el) => el.value)
    .join(' ')
    .toLowerCase();

  let gripType = null;
  if (values.includes('without')) gripType = 'without';
  if (values.includes('integrated')) gripType = 'integrated';

  document.querySelectorAll('media-gallery').forEach((gallery) => {
    gallery.filterByGripType?.(gripType);
  });
});
